export enum FlowChapterState {
  COMPLETED,
  ACTIVE,
  DISABLED,
}
